/* eslint-disable react-hooks/exhaustive-deps */
import { useDisclosure, VStack } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import Card from '../../../components/card'
import Timeline from '../../../components/timeline'
import { useAuthContext } from '../../../context/auth.context'
import { useSharedContext } from '../../../context/shared.context'
import TimelineAttachment from './timeline-attachments'
import TimelineBottomBar from './timeline/bottomBar'
import JoinAsParticipant from './timeline/joinAsParticipant'
import SendEmail from '../../../components/send-email-model'
import { doesHaveFullAccess } from '../../../utils/dashboard.utils'
import TimelineUploads from './timeline-uploads'

const TeamCollaboration = ({
	setHeader,
	setActivityTabs,
	setParticipantTabs,
	activity,
	isOverviewOpen,
	onFormSelection,
	onOpenParticipantView,
	participants = [],
	reloadParticipant,
	loadSuperAdmins = [],
	isMobileView,
	setSearchView,
	searchView,
}) => {
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: {
			timelineFilter,
			isReportingManagerLead,
			isReportingManagerOwner,
			isShowLoader,
			random,
		},
	} = useSharedContext()
	const [fileAccessTyp, setfileAccessTyp] = useState('')
	const { isOpen, onClose, onOpen } = useDisclosure()
	const [fileList, setfileList] = useState([])
	const [completedList, setcompletedList] = useState([])
	const {
		isOpen: isReply,
		onClose: onCloseReply,
		onOpen: onOpenReply,
	} = useDisclosure()
	const {
		isOpen: isSendEmail,
		onOpen: onOpenSendEmail,
		onClose: onCloseSendEmail,
	} = useDisclosure()
	const [replyData, setReplyData] = useState(null)

	let doesHaveAccess =
		!!isReportingManagerOwner ||
		!!isReportingManagerLead ||
		participants.find(item => {
			return item.asset_id === authData.asset_id
		})
	if (!doesHaveAccess) {
		doesHaveAccess = doesHaveFullAccess(authData.asset_id, doesHaveAccess)
	}

	let isSuperAdminCheck =
		!!loadSuperAdmins.length &&
		loadSuperAdmins?.find(item => item.asset_type_id === authData.asset_type_id)
	let isUserHaveAccess =
		!!loadSuperAdmins.length &&
		loadSuperAdmins.find(item => item.asset_id === authData.asset_id)

	const timelineReplyData = (data = null) => {
		setReplyData(data)
		if (!!data) {
			onOpenReply()
		} else {
			onCloseReply()
		}
	}

	const onOpenAttachment = type => {
		setfileAccessTyp(type)
		onOpen()
	}

	useEffect(() => {
		setHeader(false)
		setActivityTabs(false)
		setParticipantTabs(false)
	}, [])
	const removeFile = file => {
		let files = fileList.filter(
			f => f.name.toLowerCase() !== file.name.toLowerCase()
		)
		setfileList(files)
	}
	return (
		<Card
			w='100%'
			h='100%'
			position='relative'
			paddingTop='0px'
			// className={`team-collaborations-container`}
		>
			{isOpen ? (
				// <TimelineAttachment
				// 	isOpen={isOpen}
				// 	onClose={onClose}
				// 	activity={activity}
				// 	fileAccessTyp={fileAccessTyp}
				// />
				<TimelineUploads
					isOpen={isOpen}
					onClose={onClose}
					activity={activity}
					fileList={fileList}
					setfileList={setfileList}
					completedList={completedList}
					setcompletedList={setcompletedList}
					fileAccessTyp={fileAccessTyp}
				/>
			) : null}
			<VStack w='100%' h='100%'>
				<VStack
					// className={`team-collaborations-timeline-container`}
					w='100%'
					style={{
						transformOrigin: 'bottom',
						transition: 'transform 0.26s ease',
					}}
					maxH={
						isOverviewOpen
							? 'calc(100vh - 370px)'
							: isMobileView
							? 'calc(100vh - 170px)'
							: 'calc(100vh - 210px)'
					}
					minH={
						isOverviewOpen
							? 'calc(100vh - 370px)'
							: isMobileView
							? 'calc(100vh - 170px)'
							: 'calc(100vh - 230px)'
					}
					flex={1}
				>
					<Timeline
						onFormSelection={onFormSelection}
						activity={activity}
						filter={timelineFilter}
						timelineReplyData={timelineReplyData}
						setSearchView={setSearchView}
						searchView={searchView}
					/>
				</VStack>
				{!!authData.asset_flag_super_admin ||
				!!doesHaveAccess ||
				!!isSuperAdminCheck ||
				!!isUserHaveAccess ? (
					<TimelineBottomBar
						activity={activity}
						openAttachment={onOpenAttachment}
						onOpenParticipantView={onOpenParticipantView}
						isReplyOn={isReply}
						timelineReplyData={timelineReplyData}
						replyData={replyData}
						onOpenSendEmail={onOpenSendEmail}
						fileList={fileList}
						setfileList={setfileList}
						completedList={completedList}
						setcompletedList={setcompletedList}
						removeFile={removeFile}
						fileAccessTyp={fileAccessTyp}
						onClose={onClose}
						isMobileView={isMobileView}
					/>
				) : !!participants && participants.length ? (
					<JoinAsParticipant
						reloadParticipant={reloadParticipant}
						activity={activity}
					/>
				) : null}
				<SendEmail
					isOpen={isSendEmail}
					onClose={onCloseSendEmail}
					activity={activity}
				/>
			</VStack>
		</Card>
	)
}

export default TeamCollaboration
